import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, PageService, ParserService} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-stories-header',
    templateUrl: './block-stories-header.component.html',
})

export class BlockStoriesHeaderComponent extends BlockAbstractComponent implements OnInit {

    override currentPage : any;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
    ) {
        super(
            parser,
            auth,
            pages,
        );
    }

    override ngOnInit() {
        super.ngOnInit();
        this.currentPage = this.pages.getCurrentPage();
    }

}
